import React from 'react';
import { colors } from '../../../styles/colors';

const SortingControls = ({ onSortChange }) => {
  if (!onSortChange) return null;

  return (
    <select
      onChange={onSortChange}
      style={{
        padding: '8px 12px',
        borderRadius: '6px',
        border: `1px solid ${colors.border}`,
        backgroundColor: 'white',
        color: colors.text.primary,
        fontSize: '0.9rem',
        cursor: 'pointer',
        outline: 'none',
        '&:hover': {
          borderColor: colors.text.secondary
        },
        '&:focus': {
          borderColor: colors.primary,
          boxShadow: `0 0 0 2px ${colors.primary}25`
        }
      }}
    >
      <option value="created_at-desc">Most Recently Added</option>
      <option value="horse_name-asc">Horse Name (A-Z)</option>
      <option value="horse_name-desc">Horse Name (Z-A)</option>
      <option value="class_name-asc">Class Name (A-Z)</option>
      <option value="class_name-desc">Class Name (Z-A)</option>
      <option value="draw_number-asc">Draw Number (Low to High)</option>
      <option value="draw_number-desc">Draw Number (High to Low)</option>
      <option value="estimated_run_time-asc">Est. Run Time (Early to Late)</option>
      <option value="estimated_run_time-desc">Est. Run Time (Late to Early)</option>
    </select>
  );
};

export default SortingControls;
